import { QueryClient } from '@tanstack/react-query';

// One QueryClient instance for the whole app. Defaults are tuned for
// an internal enterprise app: data doesn't need aggressive polling,
// but should refresh on tab refocus since documents are edited by
// other users concurrently.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
